<div *ngIf="banner?.isVisible" 
    class="d-flex flex-column flex-md-row gap-2 justify-content-between align-items-center text-primary asset-inspection-notification"
>
    <div class="d-flex align-items-center gap-3">
        <div class="notification-icon-box bg-primary">
            <i class="icon app-icon icon-lg text-white" [ngClass]="banner?.icon"></i>
        </div>
        <div>{{banner?.translationString | translate}}</div>
    </div>
    <div class="d-flex gap-3">
        <a href="{{androidLink}}" target="_blank" rel="noopener noreferrer">
            <img src="assets/img/global-SVG-assets/google-play.svg" alt ="GooglePlay" />
        </a>
        <a href="{{iosLink}}" target="_blank" rel="noopener noreferrer">
            <img src="assets/img/global-SVG-assets/app-store.svg" alt ="iOS" />
        </a>
    </div>
</div>